import _ from "lodash";
import React from "react";
import classes from "./Tooltip.scss";
import MoreItemWithToolTip from "UIComponents/MoreItemWithToolTip";
import { useI18n } from "Hooks";
import { getLabelWithArchivedText } from "Utils";

const containerStyle = {
  display: "flex",
};

const generateList = ({ data, key }) => {
  const active = [];
  const archived = [];

  _.forEach(data, item => {
    const value = item[key];
    const { isArchived } = item;

    const element = <div key={value}>{value}</div>;

    if (isArchived) archived.push(element);
    else active.push(element);
  });

  return { active, archived };
};

const generateSection = ({ fields, t, label, maxLength }) => {
  return _.map(fields, field => {
    const { locale, content, showLabel, key } = field;

    if (_.isEmpty(content)) return null;

    let list = [...content];

    if (maxLength) {
      list = _.slice(content, 0, maxLength);
      const remainingCount = _.get(content, "length") - maxLength;
      if (remainingCount > 0) {
        list.push(
          t("common:and_label_more", {
            label: remainingCount,
          })
        );
      }
    }
    return (
      <span className={classes.section} key={key}>
        {showLabel && (
          <span className={classes.heading}>{t(locale, { label })}</span>
        )}
        <span className={classes.content}>{list}</span>
      </span>
    );
  });
};

const Tooltip = ({
  data = [],
  label,
  keyToMap = "title",
  maxLength,
  length,
  showArchivedSuffix,
  noItemText,
  joinSymbol,
  dir = "auto",
  ...rest
}) => {
  const { t } = useI18n(["common"]);

  const { active, archived } = generateList({
    data,
    key: keyToMap,
  });

  const fields = [
    {
      key: "ACTIVE",
      content: active,
      locale: "common:active_label",
      showLabel: !_.isEmpty(archived),
    },
    {
      key: "ARCHIVED",
      content: archived,
      locale: "common:archived_label",
      showLabel: true,
    },
  ];

  const moreComponent = (
    <div className={classes.hoverWrapper}>
      {generateSection({ fields, t, label, maxLength })}
    </div>
  );

  const renderCompWithMoreItems = () => {
    const itemsToShow = _.slice(data, 0, length);
    return (
      <div className={classes.labelContainer}>
        {_.map(itemsToShow, (item, index) => {
          const { isArchived } = item;
          const currentJoinSymbol = data.length == length ? joinSymbol : ", ";
          return (
            <div className={classes.textClass} dir={dir}>
              {getLabelWithArchivedText({
                label: item[keyToMap],
                t,
                isArchived,
              })}
              {index < _.size(itemsToShow) - 1 ? (
                <span className={classes.joinSeperator}>
                  {currentJoinSymbol}
                </span>
              ) : null}
            </div>
          );
        })}
      </div>
    );
  };

  const items = _.map(data, item => item[keyToMap]);

  return (
    <MoreItemWithToolTip
      items={items}
      length={length}
      joinSymbol={joinSymbol}
      noItemText={
        noItemText ? noItemText : t("common:no_with_label", { label })
      }
      renderMoreComponent={moreComponent}
      keyToMap={keyToMap}
      {...(showArchivedSuffix && !_.isEmpty(data)
        ? {
            renderCompWithMoreItems: renderCompWithMoreItems(),
            containerStyle: containerStyle,
          }
        : {})}
      {...rest}
    />
  );
};

Tooltip.defaultProps = {
  maxLength: 5,
  length: 1,
  joinSymbol: " & ",
  noItemText: "",
};

export default Tooltip;
